export const centers = {
    // Bemyvega: "#007680",
    Bemyvega: "#0C0C0C",
    UCAM: "#004378",
    UCO: "#131A59",
    UPCT: "#78B2E0",
    IndustrialesUPCT: "#A5272A"
};
